import { createAsyncThunk } from '@reduxjs/toolkit';
import axios, { AxiosResponse } from 'axios';

import { RootState } from '../..';
import constants from '../../../constants';
import { PutContextRequestPayload, UserContext } from '../types';

const putContext = createAsyncThunk(
  'api/put-context',
  async (payload: PutContextRequestPayload, thunkAPI) => {
    const state = thunkAPI.getState() as RootState;

    // update the Axios response to match the customer data format.
    let response: AxiosResponse<UserContext>;

    try {
      response = await axios.put(
        `${state.api.customerServiceUrl}${constants.endpoints.put.context}`,
        payload,
        {
          withCredentials: true, // Ensure credentials are sent with the request.
        },
      );
    } catch (e: unknown) {
      return thunkAPI.rejectWithValue(e);
    }

    // return data from the response.
    return response.data;
  },
);

export default putContext;
